<div class="mega-footer" *ngIf="showFooter">
    <div class="container">
        <div class="row">
            <div class="col-lg-4 col-md-6 md-mt-50 sm-mt-50">
                <div class="title-sec">
                    <img src="{{ assetURL }}/assets/images/footer-logo.png"
                        class="footer-logo1" width="100%" height="100%"
                        alt="247Invites" />
                </div>
                <p>
                    Have questions?
                </p>
                <div class="email-ready" style="font-size: 18px;">
                    Email us: <a href="mailto:support@247invites.com"
                        style="font-size: 18px;">support@247invites.com</a>
                </div>
                <div class="form-row align-items-center social-text mb-40">
                    <div class="col-md-auto col-auto">
                        <a
                            href="https://www.youtube.com/channel/UCK2kPHODEAl6HK2V7k8FUeA/featured"
                            target="_blank">
                            <img
                                src="/assets/images/new-ui/youtube-square-svgrepo.svg"
                                alt="247Invites Youtube"
                                width="32px" height="32px">
                        </a>
                    </div>
                    <div class="col-md-auto col-auto">
                        <a href="https://www.facebook.com/247invitation"
                            target="_blank">
                            <img
                                src="/assets/images/new-ui/facebook-svgrepo.svg"
                                alt="247Invites Facebook" width="32px"
                                height="32px">
                        </a>
                    </div>
                    <div class="col-md-auto col-auto">
                        <a href="https://www.instagram.com/247invite/"
                            target="_blank">
                            <img
                                src="/assets/images/new-ui/instagram-svgrepo.svg"
                                alt="247Invites Instagram"
                                width="32px" height="32px">
                        </a>
                    </div>
                </div>
            </div>
            <div class="col-lg col-md-6">
                <div class="title-sec">
                    <a [routerLink]="['/sitemap.xml']">Sitemap</a>

                </div>
                <ul class="footer-links">
                    <li [routerLink]="['/user/affiliateinfo']">Be A Seller</li>
                    <li [routerLink]="['/user/contactus']">Contact Us</li>
                    <li [routerLink]="['/user/user-review']">Customer Reviews
                    </li>
                </ul>
            </div>
            <div class="col-lg col-md-6 md-mt-50 sm-mt-50">
                <div class="title-sec">
                    Video Invitations
                </div>
                <div class="footer-links">
                    <a routerLink="/wedding-invitation-maker">Wedding
                        Invitations</a>
                    <a routerLink="/birthday-Invitation-maker">Birthday
                        Invitations</a>
                    <a routerLink="/greetings">Video
                        Greetings</a>
                    <a routerLink="/save-the-date-invitation">Save the Date
                        Invitation</a>
                    <a routerLink="/engagement-invitation">Engagement
                        Invitation</a>
                    <a routerLink="/hindu-wedding-invitation">Hindu Wedding
                        Invite</a>
                    <a routerLink="/birthday-invitation">Birthday
                        Invites</a>
                    <a routerLink="/baby-shower-invitation">Baby Shower
                        Invitation</a>
                    <a routerLink="/birthday-greetings">Birthday
                        Greetings</a>
                    <a routerLink="/diwali-invitation">Diwali Invitation</a>
                    <a routerLink="/half-saree-invitation">Half Saree
                        Invitation</a>
                    <a routerLink="/baptism-ceremony-invitation">Baptism
                        Invitation</a>
                    <a routerLink="/naming-ceremony-video-invitation">Naming
                        Naamkaran Invitation</a>
                    <a routerLink="/mundan-ceremony-Invitation">Mundan
                        Invitation</a>
                    <a routerLink="/christmas-Invitation">Christmas
                        Invitation</a>
                    <a routerLink="/house-inaugration-invitation">House Warming
                        Invitation</a>
                    <a routerLink="/south-indian-wedding-invitation">South
                        Indian Invitation</a>
                    <a routerLink="/marathi-wedding-invitation">Marathi
                        Invitation</a>
                    <a routerLink="/rajasthani-wedding-invitation">Rajasthani
                        Invitation</a>
                    <a routerLink="/pooja-invitation">Pooja Invitation</a>
                    <a routerLink="/jain-wedding-invitation">Jain
                        Invitation</a>
                    <a routerLink="/dhoti-ceremony-invitation">Dhoti Ceremony
                        Invitation</a>
                    <a routerLink="/thread-ceremony-invitation">Thread Ceremony
                        Invitation</a>
                    <a routerLink="/anniversary-invitation">Anniversary
                        Invitation</a>
                    <a routerLink="/punjabi-wedding-invitation-maker">Punjabi
                        Invitation</a>
                    <a routerLink="/muslim-wedding-invitation-maker">Muslim
                        Invitation</a>
                </div>
            </div>

        </div>
    </div>
</div>
<div class="footer" *ngIf="sharedService.isPageDataLoaded && showFooter">
    <div class="container-fluid">
        <div class="uk-width-expand@s uk-first-column">
            <div class="form-row align-items-center justify-content-center">
                <div class="col-md-auto">
                    <p>Copyright © <strong class="font-500">247Invites (OPC) PRIVATE LIMITED</strong>.
                        All Rights Reserved. </p>
                </div>
                <div class="col-md-auto col-auto">
                    <ul class="footer-links">
                        <li>
                            <a [routerLink]="['/user/terms-of-services']">Terms
                                of Service</a>
                        </li>
                        <li class="text-white">
                            |
                        </li>
                        <li>
                            <a [routerLink]="['/user/privacy-policy']">Privacy
                                Policy</a>
                        </li>
                        <li class="text-white">
                            |
                        </li>
                        <li>
                            <a [routerLink]="['/user/refund-policy']">Refund
                                Policy</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>